import React, { FC, PropsWithChildren } from 'react';

import Images from '../../state/stores/Image/images';
import { DRAWER_WIDTH } from '../../constants/layout';
import { Image, View } from 'react-native';
import { SPACING } from '../../config/designSystem/Spacing';
import { useAvailableDimensions } from '../../hooks/ui/useAvailableDimensions';



interface NavigationPanelProp extends PropsWithChildren{

  }

const NavigationPanel: FC<NavigationPanelProp> = ({children}) => {
  const WIDTH_ICON = 68;
  const HEIGHT_ICON= 38;
  const {height} = useAvailableDimensions();
  const PADDING_TOP = SPACING['sp-32'];
  const PADDING_BOTTOM = SPACING['sp-16'];
  const PADDING_HORIZONTAL = SPACING['sp-16'];
  const MARGIN_TOP = SPACING['sp-80'];


  return (
    <View style={{
      position:'absolute',
      top:0,
      left:0,
      height,
      width: DRAWER_WIDTH,
      paddingTop: PADDING_TOP,
      paddingBottom:PADDING_BOTTOM,
      paddingHorizontal: PADDING_HORIZONTAL
    }}>
      <View style={{alignItems: 'center'}}>
        <Image source={Images.logo.icon} style={ { height: HEIGHT_ICON, width: WIDTH_ICON }}></Image>
      </View>
      <View style={{marginTop: MARGIN_TOP, width: '100%', height: height-PADDING_TOP-PADDING_BOTTOM-HEIGHT_ICON- MARGIN_TOP}}>
        {children}
      </View>

    </View>  );
};



export default NavigationPanel;